define((require) => {
    "use strict";

    var ImprovedView = require("editor/zbone/ImprovedView"),
        LoggedIn     = require("shared/security/LoggedIn"),
        template     = require("ui/comments/CommentItemView.tpl");

    /**
     * Item view for a comment.
     *
     * @author Bruce Mackenzie Nielsen
     * @class CommentItemView
     * @constructor
     */
    return ImprovedView.extend({
        template: template,
        className: "comment-item-view",

        bindings: {
            ".comment-date": {
                observe: "createdAt",
                onGet: function(createdAt) {
                    return new Date(createdAt).toLocaleString();
                }
            },
            ".comment-author": {
                observe: "user",
                onGet: function(user) {
                    if (user) {
                        return LoggedIn.principal().forUser(user) ? "You: " : user.get("displayName") + ": ";
                    }
                    return "";
                }
            },
            ".comment-message": "content",
            ".comment-item-wrapper": {
                attributes: [{
                    name: "style",
                    observe: "user",
                    onGet: function(user) {
                        var colorCode = "#c6c6c6";
                        if (user) {
                            colorCode = user.get("backgroundColor");
                        }
                        return "background-color: " + colorCode;
                    }
                }, {
                    name: "class",
                    observe: "isUnread",
                    onGet: function(isUnread) {
                        if (isUnread) {
                            return "comment-item-wrapper comment-unread";
                        }

                        return "comment-item-wrapper";
                    }
                }]
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/comments/CommentItemView.js